import React from "react";
import {
  AiOutlineCheck,
  AiOutlineExclamation,
  AiOutlineInfo,
  AiOutlineClose
} from "react-icons/ai";

/**
 * Modern Premium Toast Notification Card
 * Matching exact visual design from design guide:
 * - Success: Pastel green (#F0FDF4), circular badge with green checkmark
 * - Error: Pastel rose/red (#FEF2F2), circular badge with red exclamation
 * - Warning: Pastel amber (#FFFBEB), circular badge with gold exclamation
 * - Info: Pastel sky blue (#F0F9FF), circular badge with blue info icon
 */
export const CustomToast = ({
  type = "success",
  title,
  description,
  closeToast
}) => {
  const configs = {
    success: {
      bg: "#F0FDF4",
      border: "#DCFCE7",
      iconBg: "#10B981",
      icon: <AiOutlineCheck style={{ color: "#ffffff", fontSize: "15px", strokeWidth: 32 }} />,
      defaultTitle: "Success"
    },
    error: {
      bg: "#FEF2F2",
      border: "#FEE2E2",
      iconBg: "#EF4444",
      icon: <AiOutlineExclamation style={{ color: "#ffffff", fontSize: "17px", fontWeight: "900" }} />,
      defaultTitle: "Error"
    },
    warning: {
      bg: "#FFFBEB",
      border: "#FEF3C7",
      iconBg: "#F59E0B",
      icon: <AiOutlineExclamation style={{ color: "#ffffff", fontSize: "17px", fontWeight: "900" }} />,
      defaultTitle: "Warning"
    },
    info: {
      bg: "#F0F9FF",
      border: "#E0F2FE",
      iconBg: "#0EA5E9",
      icon: <AiOutlineInfo style={{ color: "#ffffff", fontSize: "17px", fontWeight: "900" }} />,
      defaultTitle: "Information"
    }
  };

  const config = configs[type] || configs.info;
  const displayTitle = title || config.defaultTitle;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: "14px",
        padding: "16px 18px",
        backgroundColor: config.bg,
        border: `1px solid ${config.border}`,
        borderRadius: "18px",
        boxShadow: "0 12px 30px -4px rgba(0, 0, 0, 0.07), 0 4px 12px -2px rgba(0, 0, 0, 0.03)",
        position: "relative",
        minWidth: "280px",
        maxWidth: "420px",
        width: "100%",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
      }}
    >
      {/* Circular White Badge with Centered Icon */}
      <div
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          backgroundColor: "#FFFFFF",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          boxShadow: "0 2px 6px rgba(0, 0, 0, 0.06)"
        }}
      >
        <div
          style={{
            width: "24px",
            height: "24px",
            borderRadius: "50%",
            backgroundColor: config.iconBg,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          {config.icon}
        </div>
      </div>

      {/* Content: Title & Description */}
      <div style={{ flex: 1, paddingRight: "16px" }}>
        <div
          style={{
            fontSize: "14px",
            fontWeight: "700",
            color: "#0F172A",
            marginBottom: description ? "3px" : "0",
            lineHeight: "1.3"
          }}
        >
          {displayTitle}
        </div>
        {description && (
          <div
            style={{
              fontSize: "13px",
              color: "#64748B",
              lineHeight: "1.45",
              fontWeight: "400"
            }}
          >
            {description}
          </div>
        )}
      </div>

      {/* Close Button */}
      {closeToast && (
        <button
          onClick={closeToast}
          style={{
            position: "absolute",
            top: "14px",
            right: "14px",
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#94A3B8",
            transition: "color 0.2s ease"
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = "#475569")}
          onMouseLeave={(e) => (e.currentTarget.style.color = "#94A3B8")}
          aria-label="Close"
        >
          <AiOutlineClose style={{ fontSize: "14px" }} />
        </button>
      )}
    </div>
  );
};

export default CustomToast;
